import { EmptyShowcase } from "components/showcases/EmptyShowcase";
import { useProjects } from "hooks/useProjects";
import { useState } from "react";
import { ProjectShowcase } from "../ProjectShowcase";

export const ProjectsShowcase = () => {
    const { projects, loading, error } = useProjects()
    const [projectSelected, setProjectSelected] = useState(null);
    const handlerProjectSelected = (project) => setProjectSelected(project);

    if (loading) {
        return <p>Loading projects...</p>
    }
    if (error !== null) {
        return <p>There was an error meanwhile we are loading the projects.</p>
    }

    return (
        <div className="showcase">
            <div className="showcase__panel">
                <h2 className="showcase__subtitle">Projects List</h2>
                <ul className="showcase__list">
                    {!loading && projects.length === 0
                        && (
                            <p>I'm so sorry. There aren't projects to show. Please, try again.</p>
                        )}
                    {
                        projects.map(project => {
                            return (
                                <li className="showcase__item" key={project.id}>
                                    <button
                                        className="showcase__button"
                                        onClick={() => {
                                            handlerProjectSelected(project)
                                        }}
                                    >
                                        {project.title}
                                    </button>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className="showcase__demo">
                {projectSelected !== null && <ProjectShowcase project={projectSelected} />}
                {projectSelected === null && <EmptyShowcase />}
            </div>
        </div>
    )
}